import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

export type ConfirmDialogData = {
    title: string;
    message: string;
    confirmLabel?: string;
    cancelLabel?: string;
};

@Component({
    selector: 'app-confirm-dialog',
    imports: [MatDialogModule, MatButtonModule],
    templateUrl: './confirm-dialog.component.html',
    standalone: true,
})
export class ConfirmDialogComponent {
    public constructor(
        public readonly dialogRef: MatDialogRef<ConfirmDialogComponent, boolean>,
        @Inject(MAT_DIALOG_DATA) public readonly data: ConfirmDialogData,
    ) {}
}
